import InvoicesApiV2 from '@/services/shop/InvoicesApiV2'
import { PaymentMethodCode } from '@/models/shop/PaymentMethod.types'
import type { InvoiceSettingsInterface } from '@/models/shop/InvoiceSettings.types'

export class InvoiceSettingsDTO implements InvoiceSettingsInterface {
  id = ''
  arena_id = 0
  template_name = ''
  invoice_sequence_number = 0
  business_label = ''
  automatically_open_print_upon_invoice_creation = true
  invoice_footer = ''
  default_payment_method_code: PaymentMethodCode = PaymentMethodCode.CSH
}

export default class InvoiceSettings extends InvoiceSettingsDTO {
  static api = InvoicesApiV2

  constructor(DTO: InvoiceSettingsDTO) {
    super()
    Object.assign(this, DTO)
  }
}
